var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.$auth.isAuthenticated)?_c('LogoutButton'):_c('LoginButton')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }